
import { Tag } from "primereact/tag";
import { classNames } from "primereact/utils";
const MeaContractDueBalance = ({ contract, big = false }) => {
    const paid = contract?.paid_balance || 0;
    const total = contract?.total_amount || 0;
    const balance = total - paid;
    const currency = contract?.currency || "€"

    return (
        <>
            {paid === 0 && total === 0 && (<Tag value={balance + " " + currency} severity="info" className={classNames(
                { "text-2xl": big === true }
            )}></Tag>)}
            {paid === 0 && total > 0 && (<Tag value={balance + " " + currency} severity="danger" className={classNames(
                { "text-2xl": big === true }
            )}></Tag>)}
            {paid > 0 && total === 0 && (<Tag value={balance + " " + currency} severity="info" className={classNames(
                { "text-2xl": big === true }
            )}></Tag>)}
            {paid > 0 && total > 0 && paid < total && (<Tag value={balance + " " + currency} severity="warning" className={classNames(
                { "text-2xl": big === true }
            )}></Tag>)}
            {paid > 0 && total > 0 && paid === total && (<Tag value={balance + " " + currency} severity="success" className={classNames(
                { "text-2xl": big === true }
            )}></Tag>)}
            {paid > 0 && total > 0 && paid > total && (<Tag value={balance + " " + currency} severity="info" className={classNames(
                { "text-2xl": big === true }
            )}></Tag>)}
        </>
    );
};
export default MeaContractDueBalance;
